import { CopyValueBtn } from "../components/CopyValueBtn";
import { HasAttachments } from "../CRUDs/abstracts/mixins/HasAttachments";

export default{
    init(){
        if (location.pathname.includes('website-builder')) {
            this.saveActions();
            this.designActions();
            this.pagesActions();
            this.pagesValidation();
            this.createAndEditComponents();
            this.editForms();
            this.initAttachments();
            //this.initColorPicker();
            this.updateFontWeidht();
            this.addNewBlockActions();
            this.modalActions();
            this.editImageBlock();
            this.copyValBtn = new CopyValueBtn('copyValue', 'copiedValue');
        }
        this.initResizeActions();
        this.loginModal();
        this.mobileMenu();
        this.checkPageSizeForFontSize();
        var timeout =null;
    },
    pagesActions(){
        $('.delete-page-btn').click((e) => {
            const page_id = $(e.currentTarget).data('page_id');
            $.ajax({
                method: 'POST',
                url: `/settings/website-builder/${page_id}/delete`,
                success: (response) => {
                    location.reload(true);
                },
                error: (response) => {},
            });
        });
    },
    pagesValidation(){
        $('#create-business-page-form #friendly_url').on('keypress', function(event) {
            const inputValue = String.fromCharCode(event.which);
            if (!/[a-z0-9-_]/.test(inputValue)) {
                event.preventDefault(); // Отменяем ввод символа, если он не является числом или точкой
            }
        })
    },
    saveActions(){
        $('.create-business-page').click((e)=>{
            e.preventDefault();
            if (this.validation('.create-business-page-form')) {
                let form = $('#create-business-page-form')[0];
                let data = new FormData(form);
                // console.log(data, form);
                $.ajax({
                    method: 'POST',
                    url: '/settings/website-builder/create',
                    data: data,
                    enctype: 'multipart/form-data',
                    processData: false,
                    contentType: false,
                    success: (response)=>{
                        console.log(response);
                        location.href = '/settings/website-builder/';
                    },
                    error: (response) => {
                        // console.log(response);
                        this.showFlyError(response.responseJSON.errors);
                    }
                });
            }
        });
    },
    validation(form_name){
        let $is_valid=true;
        const form = $(form_name);
        form.find('input').css('border-color', '');
        if (form.find('#page_name').val() == '') {
            form.find('#page_name').css('border-color', 'red');
            $is_valid=false;
        }
        if (form.find('#friendly_name').val() == '') {
            $is_valid=false;
            form.find('#friendly_name').css('border-color', 'red');
        }
        if (form.find('#title').val() == '') {
            $is_valid=false;
            form.find('#title').css('border-color', 'red');
        }

        return $is_valid;
    },
    designActions(){
        $('body').on('click','.edit-design-elemnt-btn', (e) => {
            /* const editable_elem = $(e.currentTarget).parent().find('.editable-elem');
            const edit_input = $(e.currentTarget).parent().find('.edit-input');
            if ($(editable_elem).hasClass('d-none')) {
                $(editable_elem).removeClass('d-none');
                $(edit_input).addClass('d-none');
            } else {
                $(editable_elem).addClass('d-none');
                $(edit_input).removeClass('d-none');
            } */

            if ($(e.currentTarget).hasClass('icon')) {
                const currentElem = $(e.currentTarget);
                HasAttachments.QueryData = {
                    component_id: $(e.currentTarget).data('component_id'),
                    component_type: $(e.currentTarget).data('component_type'),
                };
                HasAttachments.SuccessCallback = (r) => {
                    console.log("callback header", currentElem, currentElem.parent().find('section'), r.path);
                    if (currentElem.data('component_type') == 'header_image') {
                        currentElem.parent().find('section').css('background-image', `url(${r.path})`);
                    } else if(currentElem.data('component_type') == 'footer_image') {
                        $('.site-footer').find('style').text(
                            '.site-footer::before{'+
                                `background-image: url('${r.path}');`+
                            '}'
                        );

                        //$(e.currentTarget).parent().find('section').css('background-image', r.path);
                    }else{
                        location.reload(true);
                    }

                };
            }else if($(e.currentTarget).hasClass('block')){
                const data = {
                    form_type: 'edit',
                    block_id: $(e.currentTarget).data('block_id'),
                    item_type: $(e.currentTarget).data('item_type'),
                    content_type: $(e.currentTarget).data('content_type'),
                };
                this.showEditElementForm(data);
            }else if ($(e.currentTarget).hasClass('block-parts')) {
                const data = {
                    form_type: 'select_part',
                    block_id: $(e.currentTarget).data('block_id'),
                    item_type: $(e.currentTarget).data('item_type'),
                };
                if ($('.select_block_part_modal').length > 0) {
                    $('.select_block_part_modal').remove();
                } else {
                    this.showEditElementForm(data, (response, target)=>{
                        $('#form-container').html(response);
                        $('.select_block_part_modal');
                        let posX = $(target).offset().left + $(target).width() + 10;
                        if ($(target).width() < $(`.select_block_part_modal`).width()) {
                            posX = $(target).offset().left - ($('.select_block_part_modal').width() - $(target).width());
                        }
                        let posY = $(target).offset().top + $(target).width()+10;
                        $('.select_block_part_modal').css({left: posX, top: posY, visibility: 'visible'});
                    }, e.currentTarget);
                }
            } else {
                const data = {
                    form_type: 'edit',
                    item_type: $(e.currentTarget).data('item_type'),
                    item_id: $(e.currentTarget).data('content_id'),
                    content_type: $(e.currentTarget).data('content_type'),
                    content_part: $(e.currentTarget).data('content_part')
                };
                this.showEditElementForm(data);
            }
        })
        $('body').on('click','.select_block_part_modal .close-elem', function() {
            $('.select_block_part_modal').remove();
        })
        $('body').off('click', '.edit_block_text').on('click', '.edit_block_text', (e) => {
            $('.select_block_part_modal').remove();
            const data = {
                form_type: 'edit',
                block_id: $(e.currentTarget).data('block_id'),
                item_type: 'block',
            };
            this.showEditElementForm(data);
        });
        $('body').off('click', '.edit_block_button').on('click', '.edit_block_button', (e) => {
            $('.select_block_part_modal').remove();
            const data = {
                form_type: 'edit',
                item_id: $(e.currentTarget).data('component_id'),
                item_type: 'button',
                content_type: $(e.currentTarget).data('content_type'),
            };
            this.showEditElementForm(data);
        });

        $('.edit-input').on('change', (e) => {
            const editing_type = $(e.currentTarget).data('editing-type');
            const editing_component = $(e.currentTarget).data('editing-component');
            const page_id = $('#page_id').val();
            const edited_value = $(e.currentTarget).val();
            let data = {
                editing_type:editing_type,
                editing_component:editing_component,
                edited_value:edited_value
            };
            if (editing_type == 'component') {
                data.component_id = $(e.currentTarget).data('component-id');
            }
            this.updateDesign(data, $(e.currentTarget).parent());
        });

        $('body').off('click','.add-component-btn').on('click','.add-component-btn', (e) => {
            const data = {
                form_type: 'add',
                item_type: 'component',
                block_id: $(e.currentTarget).data('block_id'),
                content_type: $(e.currentTarget).data('content_type'),
            };
            this.showEditElementForm(data);
        });
        $('.add-content-block-btn').click((e) => {
            const data = {
                form_type: 'add',
                item_type: 'content_block',
            };
            this.showEditElementForm(data);
        });
        $('.update-component-btn').click((e) => {
            const component_id = $(e.currentTarget).data('id');
            const data = {
                form_type: 'edit',
                item_type: 'component',
                item_id: component_id,
            };
            this.showEditElementForm(data);
        });
        $('body').on('click','.delete-component-btn', (e) => {
            const page_id = $('#page_id').val();
            const block_id = $(e.currentTarget).data('block_id');
            // return;
            const elem = $(e.currentTarget);
            const component = $(e.currentTarget).parents('.component-image-container');
            $.ajax({
                method: "POST",
                url: `/settings/website-builder/${page_id}/component/delete`,
                data: {
                    id: $(e.currentTarget).data('id'),
                },
                success: (response) => {
                    // console.log($(e.currentTarget).hasClass('image'), $(e.currentTarget));
                    if (elem.hasClass('image')) {
                        component.css('opacity', '0.4');
                        component.find('.close-menu').click();
                        component.addClass('lock-block');
                    }else if(response.view){
                        $(`.block-${block_id}`).html(response.view);
                    }else{
                        location.reload(true);
                    }
                },
                error: (response) => {

                }
            });
        });
        $('body').on('change', '#item_type', function(e) {
            if ($(this).val() == 'link') {
                $('#related_page').parent().removeClass('d-none');
            }else{
                $('#related_page').parent().addClass('d-none');
            }
        })
        $('body').on('change', '#add-content-block-modal #content_type', function() {
            if ($(this).val() == 4) {
                $('#add-content-block-modal #description').parent().removeClass('d-none');
            } else {
                $('#add-content-block-modal #description').parent().addClass('d-none');
            }
        })

        $('body').on('click','.hide-component-btn', function(e) {
            const component_id = $(this).data('id');
            const block_id = $(this).data('block_id');
            const page_id = $('#page_id').val();
            const elem = $(this);

            $.ajax({
                method: "POST",
                url: `/settings/website-builder/${page_id}/component/hide`,
                data: {
                    id: component_id,
                },
                success: (response) => {
                    if (response.view) {
                        if ($(`.block-${block_id}`).hasClass('site-footer__info') || $(`.block-${block_id}`).hasClass('titles')) {
                            let current_block = $(`.block-${block_id}`);
                            $(`.block-${block_id}`).after(response.view);
                            current_block.remove();
                        }else{
                            $(`.block-${block_id}`).html(response.view);
                        }
                    } else {
                        // onst container = elem.parents('.editable-continer');
                        // ontainer.find('.editable-elem').toggleClass('opacity-40');

                        location.reload(true);
                    }
                },
                error: (response) => {

                }
            });
        });

        $('body').on('click','.delete-block-btn', (e)=>{
            const page_id = $('#page_id').val();
            const block_id = $(e.currentTarget).data('id');
            $.ajax({
                method: "POST",
                url: `/settings/website-builder/${page_id}/blocks/delete`,
                data: {
                    id: block_id,
                },
                success: (response) => {
                    $(`.block-${block_id}`).next().remove();
                    $(`.block-${block_id}`).remove();
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });

        $('body').off('change', '#component_logo').on('change', '#component_logo', function(e) {
            if (this.value !== '') {
                $(this).parent().find('label.file-label').text(this.files[0].name);
                $(this).parent().removeClass('col-8').addClass('col-12');
                $(this).parents('.form-row').find('img').parent().addClass('d-none');
            }
        });
    },

    showEditElementForm(data = {}, callback=false, target=null){
        data.page_id = $('#page_id').val();
        $.ajax({
            method: 'POST',
            url: '/settings/website-builder/get-form',
            data: data,
            success: (response) => {
                if (callback !== false) {
                    callback(response, target);
                } else {
                    $('#form-container').html(response);
                    $('#form-container').find('.modal').modal('show');
                    this.initColorPicker();
                }
            },
            error: (response) => {}
        });
    },

    updateDesign(data){
        const url = location.pathname+'/update';
        $.ajax({
            method: 'POST',
            url: url,
            data: data,
            success: (response) =>{
                location.reload(true);
            },
            error: (response) => {}
        });
    },

    createAndEditComponents(){
        $('body').off('.create-component-btn').on('click', '.create-component-btn', (e) => {
            const form = $(e.currentTarget).parents('form');
            const page_id = $('#page_id').val();
            const block_id = $(e.currentTarget).data('block_id');
            const modal = $(e.currentTarget).parents('.modal');
            let data = new FormData($(form)[0]);
            $.ajax({
                method: 'POST',
                url: `/settings/website-builder/${page_id}/component/create`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response)=>{
                    if (response.view) {
                        $(`.block-${block_id}`).html(response.view);
                        $(modal).modal('hide');
                    } else {
                        location.reload(true);
                    }
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });
        $('body').off('.edit-component-btn').on('click', '.edit-component-btn', (e) => {
            const form = $(e.currentTarget).parents('form');
            const block_id = $(e.currentTarget).data('block_id');
            const page_id = $('#page_id').val();
            let data = new FormData($(form)[0]);
            $.ajax({
                method: 'POST',
                url: `/settings/website-builder/${page_id}/component/update`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response)=>{
                    if (response.view) {
                        $(`.block-${block_id}`).html(response.view);
                        $('#form-container').find('.modal').modal('hide');
                    }else{
                        location.reload(true);
                    }
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });
        $('body').off('.create-content-block-btn').on('click', '.create-content-block-btn', (e)=>{
            e.preventDefault();
            const form = $(e.currentTarget).parents('form');
            const page_id = $('#page_id').val();
            let data = new FormData($(form)[0]);

            $.ajax({
                method: 'POST',
                url: `/settings/website-builder/${page_id}/component/create`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response)=>{
                    location.reload(true);
                },
                error: (response) => {
                    console.log(response);
                }
            });

        });

        $('body').off('.edit-block-btn').on('click','.edit-block-btn', (e)=> {
            const form = $(e.currentTarget).parents('form');
            const modal = $(e.currentTarget).parents('.modal');
            const block_id = $(e.currentTarget).data('block_id');
            /* if (form.length == 0) {
                location.reload(true);
            } */
            const page_id = $('#page_id').val();
            let data = new FormData($(form)[0]);
            if (form.length == 0) {
                data.append('id', block_id);
            }
            $.ajax({
                method: 'POST',
                url: `/settings/website-builder/${page_id}/blocks/update`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: (response)=>{
                    if (response.view) {
                        console.log(block_id);
                        if ($(`.block-${block_id}`).hasClass('site-footer__info') || $(`.block-${block_id}`).hasClass('titles')) {
                            let current_block = $(`.block-${block_id}`);
                            $(`.block-${block_id}`).after(response.view);
                            current_block.remove();
                        } else {
                            $(`.block-${block_id}`).html(response.view);
                        }
                        $(modal).modal('hide');
                    }else{
                        location.reload(true);
                    }
                },
                error: (response) => {
                    console.log(response);
                }
            });
        });
    },

    editForms(){
        $('body').off('change', '#edit-form-modal #form_type').on('change', '#edit-form-modal #form_type', (e) => {
            if ($(e.currentTarget).val() == 'service-request') {
                $('#edit-form-modal #form_service').parent().removeClass('d-none');
            }else{
                $('#edit-form-modal #form_service').parent().addClass('d-none');
            }
        });
        $('body').off('click', '#edit-form-modal .save-form-btn').on('click','#edit-form-modal .save-form-btn', (e) => {
            const editing_component = $(e.currentTarget).data('editing-component');
            const edited_value = JSON.stringify({
                form_type: $('#edit-form-modal form').find('#form_type').val(),
                form_service: $('#edit-form-modal form').find('#form_service').val()
            });
            let data = {
                editing_type: 'form',
                editing_component:editing_component,
                edited_value:edited_value,
            };

            this.updateDesign(data);
        });
    },

    initAttachments(){
        if (window.location.pathname.includes('/settings/website-builder')) {
            HasAttachments.id = $('#page_id').val();
            HasAttachments.urlRoot = '/settings/website-builder';
            HasAttachments.isHightQuality = true;
            HasAttachments.scopeOpenDropZoneListener({}, ()=>{});
        }
    },
    initColorPicker(){
        $('#description_text_color').colorpicker();
        $('#title_text_color').colorpicker();
        $('#button_text_color').colorpicker();
        $('#button_background').colorpicker();
    },
    moveElement() {
        const forms = [{
            elementToMove: document.getElementById('header-form'),
            targetLocation: document.getElementById('primary'),
            container: document.querySelector('.major-banner .page-container'),
            mode: 'prepend',
        }, {
            elementToMove: document.getElementById('footer-form'),
            targetLocation: document.getElementById('primary'),
            container: document.querySelector('.site-footer__form'),
            mode: 'append',
        }];
        forms.forEach((form) => {
            if (form.elementToMove && form.targetLocation && form.container) {
                if (window.innerWidth < 1000 && !form.elementToMove.parentNode.isEqualNode(form.targetLocation)) {
                    form.mode === 'append' ? form.targetLocation.appendChild(form.elementToMove) : form.targetLocation.prepend(form.elementToMove);
                } else if (window.innerWidth >= 1000 && !form.elementToMove.parentNode.isEqualNode(form.container)) {
                    form.container.appendChild(form.elementToMove);
                }
            }
        });
    },
    handleResize(self) {
        clearTimeout(self.timeout);
        self.timeout = setTimeout(() => {
            self.moveElement();
            //self.updateFontSizes();
        }, 30);
    },
    initResizeActions(){
        let self = this;
        /* document.addEventListener('DOMContentLoaded', ()=>{
            console.log('DOMContentLoaded');

            self.moveElement(self)
        }); */
        $(document).ready(() => {
            self.moveElement(self)
        });
        // window.addEventListener('resize', self.handleResize(self));
        $(window).on('resize', ()=>{
            self.handleResize(self);
        });
        window.addEventListener('load', ()=>{
            self.moveElement(self)
        });

        // let iframe = document.querySelector('#job-request-bizbaby iframe');
        // iframe.addEventListener('load', function () {
        //     this.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        // });
    },
    loginModal(){
        $('.login-open').click((e)=>{
            const modal = document.getElementById('login-modal')
            modal.style.zIndex = '999999';
            modal.style.opacity = '1';
            modal.style.visibility = 'visible';
            $(modal).modal('show');

            window.addEventListener( 'click', ( event ) => {
				if ( event.target === modal ) {
					modal.style.zIndex = '-999999';
                    modal.style.opacity = '0';
                    modal.style.visibility = 'hidden';
                    $(modal).modal('hide');
				}
			} );
        });
    },
    mobileMenu(){
        $('.menu-toggle').click(function() {
            const button = $(this)[0];
            const siteNavigation = $(this).parents('.main-navigation')[0];
            $(siteNavigation).toggleClass('toggled');
            if ( $(this).attr( 'aria-expanded' ) === 'true' ) {
				$(this).attr( 'aria-expanded', 'false' );
			} else {
				$(this).attr( 'aria-expanded', 'true' );
			}
            document.addEventListener(
                'click',
                function( event ) {
                    const isClickInside = siteNavigation.contains( event.target );

                    if ( ! isClickInside ) {
                        siteNavigation.classList.remove( 'toggled' );
                        button.setAttribute( 'aria-expanded', 'false' );
                    }
                }
            );
        });

    },
    updateFontWeidht(){
        $('body').off('change', '.component_font_family')
        .on('click', '.component_font_family', function() {
            const selectedOption = $(this).find('option:selected');
            const font_class = selectedOption[0].classList[0];
            this.classList.forEach((element,index) => {
                console.log(element,index);
                if (element.indexOf('ff-')>=0) {
                    $(this).removeClass(this.classList[index]);
                }
            });
            $(this).addClass(font_class);
        });
    },

    showFlyError(errors){
        $('.fly-errors-container').html('');

        errors.forEach(element => {
            let parent = $(`#${element.name}`).parent();
            $(`#${element.name}`).css('border-color', 'red');
            $(parent).find('.fly-error-message').remove();
            //$('.fly-errors-container').append(
            $(parent).append(
                `<div class="fly-error-message ${element.name}">`+
                `${element.error_message}`+
                '<div>'
            );
            let posX = $(`#${element.name}`).position().left + 10;
            let posY = $(`#${element.name}`).position().top - $(parent).find('.fly-error-message').height() - 40;
            // console.log($(`#${element.name}`).offset(), $(`#${element.name}`).position());

            $(`.fly-error-message.${element.name}`).css({top:posY, left:posX});
            setTimeout(() => {
                $(`.fly-error-message.${element.name}`).hide();
            }, 5000);
        });
    },
    addNewBlockActions(){
        $('body').off('click','.add-block-btn')
        .on('click','.add-block-btn',function(e) {
            const container = $(this).parents('.add-block-section');
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(container).find('.blocks-options').addClass('hidden');
                $(container).find('.select-block-btn').removeClass('selected');
                $(container).find('.images-block-options').addClass('hidden');
                $(container).find('.text-block-options').addClass('hidden');
                $(container).find('.video-block-options').addClass('hidden');
                $('.back-select-block').addClass('hidden');
            } else {
                $(this).addClass('active');
                $(container).find('.blocks-options').removeClass('hidden');
            }
        });
        $('body').off('click','.select-block-btn')
        .on('click','.select-block-btn',function(e) {
            let container = $(this).parents('.add-block-section');
            const section = $(this).data('section');
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
                $(container).find('.back-select-block').addClass('hidden');
            } else {
                $(container).find('.select-block-btn').removeClass('selected');
                $(this).addClass('selected');
                $(container).find('.back-select-block').removeClass('hidden');
                $(container).find('.blocks-options').addClass('hidden');
                $(container).find(`.${section}-block-options`).removeClass('hidden');
            }
        });
        $('body').off('click','.back-select-block').on('click','.back-select-block',function() {
            let container = $(this).parents('.add-block-section');
            $(this).addClass('hidden');
            $(container).find('.blocks-options').removeClass('hidden');
            $(container).find('.images-block-options').addClass('hidden');
            $(container).find('.text-block-options').addClass('hidden');
            $(container).find('.video-block-options').addClass('hidden');
        });

        $('body').off('click','.block-option')
        .on('click', '.block-option', function(e) {
            const page_id = $('#page_id').val();
            const type = $(this).data('block_type');
            const position = $(this).data('position');
            const subtype = $(this).data('subtype') ?? null;
            const curr_elem = $(this);
            const container = curr_elem.parents('.add-block-section');
            let data = {
                block_type: type,
                position: position,
                type_view: subtype,
            };
            //console.log(data);

            $.ajax({
                method: 'POST',
                url: `/settings/website-builder/${page_id}/blocks/create`,
                data: data,
                success: (response)=>{
                    console.log(response);

                    if (response.view) {
                        $(container).find('.add-block-btn').click();
                        $(container).after(response.view);
                    } else {
                        location.reload(true);
                    }
                },
                error: (response) => {
                    console.log(response);
                }
            });

        });
    },

    modalActions(){
        $('body').off('click', '.switch-component-settings')
        .on('click', '.switch-component-settings', function() {
            $('.switch-component-settings').removeClass('active');
            $(this).addClass('active');
            const container = $(this).parents('.component-settings-container');
            const tab_name = $(this).data('tab_name');
            const settings_tab = $(container).find(`.${tab_name}-tab`);

            $('.settings-tab').addClass('d-none');
            $(settings_tab).removeClass('d-none');
        })

        $('body').off('input', '.component-settings-container #video_url')
        .on('input', '.component-settings-container #video_url', function() {
            console.log($(this).val());
            const regexp = /^https:\/\/www.youtube.com\/\w+/;
            const regexp_short = /^https:\/\/youtu.be\/\w+/;
            if (regexp.test($(this).val())) {
                $(this).parents('form').find('.edit-component-btn').removeAttr('disabled');
            }else if(regexp_short.test($(this).val())){
                $(this).parents('form').find('.edit-component-btn').removeAttr('disabled');
            }else{
                $(this).parents('form').find('.edit-component-btn').attr('disabled', 'disabled');
            }
        })

        $('body').off('click', '.hide-elem-btn').on('click', '.hide-elem-btn', function() {
            const element = $(this).data('elem');
            const elem_id = $(this).data('id');
            if ($(`#${element}`).val() == 0) {
                $(`#${element}`).val(1);
                $(`#${element}`).parent().find('.hide-elem').removeClass('d-none');
                $(`#${element}`).parent().find('.show-elem').addClass('d-none');

                if (elem_id) {
                    $(`#${element}`).parents('form').find(`.hidable-elem-${elem_id}`).addClass('opacity-40');
                }
            }else{
                $(`#${element}`).val(0)
                $(`#${element}`).parent().find('.hide-elem').addClass('d-none');
                $(`#${element}`).parent().find('.show-elem').removeClass('d-none');

                if (elem_id) {
                    $(`#${element}`).parents('form').find(`.hidable-elem-${elem_id}`).removeClass('opacity-40');
                }
            }
        })
    },

    editImageBlock(){
        $('body').on('click','.block-images-components .file-menu', (e) => {
            e.preventDefault();
            const container = $(e.currentTarget).parents('.component-image-container');
            container.find('.image-control-menu').removeClass('hided');
            container.find('.image-tab').addClass('hided');
        });
        $('body').on('click', '.block-images-components .close-menu', (e)=>{
            const container = $(e.currentTarget).parents('.component-image-container');
            container.find('.image-control-menu').addClass('hided');
            container.find('.image-tab').removeClass('hided');
        });

        $('body').on('click', '.upload-image-btn', (e)=>{

            const data = {
                form_type: 'edit',
                block_id: $(e.currentTarget).data('block_id'),
                item_type: $(e.currentTarget).data('item_type'),
                content_type: $(e.currentTarget).data('content_type'),
            };
            this.showEditElementForm(data);


            const container = $(e.currentTarget).parents('.modal-body').find('.block-images-components');

            HasAttachments.QueryData = {
                block_id: $(e.currentTarget).data('block_id'),
            };
            HasAttachments.SuccessCallback = (r) => {
                console.log(r, container);
                $(container).html(r.view);
            };
        })
    },

    checkPageSizeForFontSize(){

        this.updateFontSizes();
        /* let elems = $('#page header').find('h2, h3').toArray();
        elems.forEach(element => {
            let font_size = $(element).css('font-size').replace('px','');
            font_size *= 0.7;
            $(element).css('font-size', font_size);
        }); */
    },

    updateFontSizes(){
        const elem_k = {
            header: {
                h2: '0.7',
                h3: '0.9'
            }
        }
        if (window.innerWidth>768) {

        } else {
            for (const key in elem_k) {
                if (Object.hasOwnProperty.call(elem_k, key)) {
                    const element_options = elem_k[key];
                    let container = $(key);
                    for (const key2 in element_options) {
                        if (Object.prototype.hasOwnProperty.call(element_options, key2)) {
                            let elem = $(container).find(key2);
                            let font_size = $(elem).css('font-size').replace('px','');
                            font_size *= element_options[key2];
                            $(elem).css('font-size', font_size);
                        }else{
                            console.log('неизвестная ошибка 1', );
                        }
                    }
                }else{
                    console.log('неизвестная ошибка 2');

                }
            }
        }
    }
}
